<script>
import Multiselect from 'vue-multiselect'

export default {

    name: 'custom-multiselect',

    components: { Multiselect },

    props: {
        options: null,
        searchable: Boolean,
        placeholder: String,
        selectedValue: null,
        label: String,
        labelInline: Boolean,
        modelLabel: String,
        multiple: Boolean,
        labelClasses:String,
        afterList: Boolean,
        noRadius: Boolean,
        isSmall: Boolean,
    },

    data() {
        return {
            selected: null,
        }
    },

    methods: {
        select()
        {
            this.$emit('selected', this.selected)
        },
    },

    watch:
    {
        selectedValue()
        {
            this.selected = this.selectedValue
        }

    },

    mounted() {
        if (this.selectedValue) {
            this.selected = this.selectedValue
        }
    }

}
</script>

<template lang="html">

    <div 
        v-if="options && options instanceof Array" 
        class="engage-multiselect"
        :class="{ 'inlineLabel' : labelInline, 'no-select' : options.length == 1, 'withAfter': afterList, 'no-radius': noRadius, 'smaller':isSmall, 'multiple': multiple  }">

        <label v-if="label" :class="labelClasses"> {{ label }} </label>

        <multiselect
         v-model="selected"
         @input="select"
         :placeholder="placeholder"
         :options="options"
         :searchable="searchable"
         :close-on-select="true"
         :multiple="multiple"
         :label="modelLabel"
         :allow-empty="false">
         <div v-if="afterList" class="multiselect-after" slot="afterList">
             <slot name="after"></slot>
         </div>
        </multiselect>

     </div>

</template>



// WEBPACK FOOTER //
// src/components/forms/elements/multiselect.vue